import React, { useEffect, useState, useRef } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col } from "react-bootstrap";
import OtherService from "../services/Other";
import Loader from "../component/Loader";
import RegistrationService from "../services/registration";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import { useNavigate } from "react-router-dom";
import { Home } from "react-feather";
import toast from "react-hot-toast";
import NoData from '../component/NoData'

const ReferralList = () => {
  const [loadingst, setLoadingst] = useState(false);
  const [referList, setReferList] = useState([]);
  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;

  useEffect(() => {
    getList();
  }, [brandId]);

  const getList = async () => {
    setLoadingst(true);
    try {
      const res = await OtherService.referralList();
      setLoadingst(false);
      if (res.success) {
        let list = res.response;
        let updatedList = list.flatMap((group) =>
          group.referred_contacts.map((contact) => ({
            ...contact,
            referrer_code: group.referrer_code,
          }))
        );
        // if (type == 'comp') {
        //     updatedList = updatedList.slice(0, 3);
        // }
        setReferList(updatedList);
      } else {
        setReferList([]);
        const obj = res.response.error;
      }
    } catch (e) {
      setReferList([]);
      setLoadingst(false);
    }
  };

  return (
    <>
      <BreadCrumbSecttion
        pageTitle="Referral List"
        currentPageName="Referral List"
      />
      <section className="padTop50">
        <Container>
          <Row>
            {referList?.map((item, index) => {
              const { name, referrer_code, referred_at, registered_at } = item;
              return (
                <Col xs={12} md={6} lg={4} key={index} className="mb-4">
                  <div
                    className={`addressBlock `}
                  >
                    <div className="addressBlockWrap">
                      <div className="addressBlockArea">
                        <div className="addressTxtWrap">
                          <div className="firstBlock">Name</div>
                          <div className="secondBlock">{item?.name}</div>
                        </div>

                        <div className="addressTxtWrap">
                          <div className="firstBlock">Referral Code</div>{" "}
                          <div className="secondBlock">
                            {item?.referrer_code}
                          </div>
                        </div>

                        <div className="addressTxtWrap">
                          <div className="firstBlock">Refered At</div>{" "}
                          <div className="secondBlock">
                            {new Date(item.referred_at).toLocaleString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                                hour12: true,
                              }
                            )}
                          </div>
                        </div>

                        <div className="addressTxtWrap">
                          <div className="firstBlock">Registered At</div>
                          <div className="secondBlock">
                            {new Date(item.registered_at).toLocaleString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                                hour12: true,
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
            {referList.length === 0 && !loadingst && <NoData />}
            {referList.length === 0 && loadingst && <NoData title="fetching.." />} 
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ReferralList;
